import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Settings, Shield, User, CheckCircle } from 'lucide-react';
import AccountInfoSection from './sections/AccountInfoSection';
import SecuritySection from './sections/SecuritySection';
import PreferencesSection from './sections/PreferencesSection';
import VerificationSection from './sections/VerificationSection';
import styles from './GlobalSettings.module.css';

/**
 * GlobalSettings Component
 * Main settings page with sidebar navigation
 * Uses JACKOPOT design system colors and proper socket integration
 */
const GlobalSettings = () => {
  const [searchParams] = useSearchParams();
  const sectionParam = searchParams.get('section');
  
  // Map URL section param to section name
  const sectionMap = {
    'verification': 'Personal Verification',
    'security': 'Security',
    'account': 'Account Info',
    'preferences': 'Preferences'
  };
  
  const initialSection = sectionParam && sectionMap[sectionParam] 
    ? sectionMap[sectionParam] 
    : 'Account Info';
  
  const [activeSection, setActiveSection] = useState(initialSection);

  // Update active section when URL param changes
  useEffect(() => {
    if (sectionParam && sectionMap[sectionParam]) {
      setActiveSection(sectionMap[sectionParam]);
    }
  }, [sectionParam]);

  const sideContentItems = [
    { 
      name: 'Account Info', 
      component: AccountInfoSection,
      icon: User
    },
    { 
      name: 'Security', 
      component: SecuritySection,
      icon: Shield
    },
    { 
      name: 'Preferences', 
      component: PreferencesSection,
      icon: Settings
    },
    { 
      name: 'Personal Verification', 
      component: VerificationSection,
      icon: CheckCircle
    },
  ];

  const ActiveComponent =
    sideContentItems.find((item) => item.name === activeSection)?.component ||
    (() => null);

  return (
    <div className={styles.container}>
   

      {/* Main Content */}
      <div className={styles.contentWrapper}>
        {/* Sidebar */}
        <div className={styles.sidebar}>
          {sideContentItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.name}
                className={`${styles.sidebarItem} ${activeSection === item.name ? styles.sidebarItemActive : ''}`}
                onClick={() => setActiveSection(item.name)}
              >
                <Icon size={18} className={styles.sidebarIcon} />
                <span>{item.name}</span>
              </button>
            );
          })}
        </div>

        {/* Main Content Area */}
        <div className={styles.mainContent}>
          <ActiveComponent />
        </div>
      </div>
    </div>
  );
};

export default GlobalSettings;
